const showBrowserToast = (message) => {
  if (typeof window === "undefined") {
    return;
  }

  window.setTimeout(() => {
    window.alert(message);
  }, 0);
};

export const showErrorToast = (message = "Da xay ra loi") => {
  console.error(message);
  showBrowserToast(message);
};

export const showSuccessToast = (message = "Thanh cong") => {
  console.log(message);
  showBrowserToast(message);
};

export const showInfoToast = (message = "Thong bao") => {
  console.info(message);
  showBrowserToast(message);
};
